import { render, staticRenderFns } from "./AcceptInvoicesModal.vue?vue&type=template&id=3c8f0ad4&"
import script from "./AcceptInvoicesModal.vue?vue&type=script&lang=js&"
export * from "./AcceptInvoicesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports